import { Link } from 'react-router-dom';
import Icon from '@/components/base/Icon';

export const WHATSAPP_NUMBER = '5544997181872';

export const WHATSAPP_ORCAMENTO = `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(
  'Olá! Gostaria de solicitar um orçamento.'
)}`;

export const WHATSAPP_CONTATO = `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(
  'Olá! Gostaria de falar com um especialista.'
)}`;

interface WhatsAppCTAButtonsProps {
  size?: 'sm' | 'md' | 'lg';
  layout?: 'row' | 'column' | 'row-responsive';
  className?: string;
}

export function WhatsAppCTAButtons({
  size = 'md',
  layout = 'row-responsive',
  className = '',
}: WhatsAppCTAButtonsProps) {
  const sizeClasses = {
    sm: 'px-4 py-2 text-sm',
    md: 'px-5 py-2.5 text-sm',
    lg: 'px-7 py-3.5 text-base',
  };

  const layoutClasses = {
    row: 'flex-row',
    column: 'flex-col',
    'row-responsive': 'flex-col sm:flex-row',
  };

  return (
    <div className={`flex items-stretch gap-3 ${layoutClasses[layout]} ${className}`}>
      <a
        href={WHATSAPP_ORCAMENTO}
        target="_blank"
        rel="noopener noreferrer"
        aria-label="Solicitar orçamento pelo WhatsApp"
        className={`inline-flex items-center justify-center gap-2 bg-green-900 text-white font-bold rounded-full hover:bg-green-950 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-green-950 transition-all hover:scale-105 whitespace-nowrap shadow-lg ${sizeClasses[size]}`}
      >
        <span className="w-4 h-4 flex items-center justify-center" aria-hidden="true">
          <Icon name="whatsapp" className="text-white" size={16} />
        </span>
        Solicite um Orçamento
      </a>

      <a
        href={WHATSAPP_CONTATO}
        target="_blank"
        rel="noopener noreferrer"
        aria-label="Falar com especialista pelo WhatsApp"
        className={`inline-flex items-center justify-center gap-2 bg-slate-950 text-white font-bold rounded-full hover:bg-black focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-slate-950 transition-all hover:scale-105 whitespace-nowrap shadow-lg ${sizeClasses[size]}`}
      >
        <span className="w-4 h-4 flex items-center justify-center" aria-hidden="true">
          <Icon name="whatsapp" className="text-white" size={16} />
        </span>
        Fale Conosco
      </a>
    </div>
  );
}

export function WhatsAppInlineLink({ text }: { text?: string }) {
  return (
    <a
      href={WHATSAPP_ORCAMENTO}
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Falar no WhatsApp"
      className="inline-flex items-center gap-1 text-green-950 font-bold hover:text-black hover:underline focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-green-950"
    >
      <span className="w-4 h-4 flex items-center justify-center" aria-hidden="true">
        <Icon name="whatsapp" size={16} />
      </span>
      {text || 'Falar no WhatsApp'}
    </a>
  );
}

export function BackToBlog() {
  return (
    <Link
      to="/"
      aria-label="Voltar ao blog"
      className="inline-flex items-center gap-1 text-sm text-red-800 font-semibold hover:text-red-950 transition-colors mb-4 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-red-950"
    >
      <span className="w-4 h-4 flex items-center justify-center" aria-hidden="true">
        <Icon name="arrow-left" size={16} />
      </span>
      <span>Voltar ao Blog</span>
    </Link>
  );
}